import ability from './ability'
import { canAccessAdminSettings } from '@/utils/admin-settings-permissions'
import { canAccessClientDashboard } from '@/utils/client-dashboard-permissions'

const canAccessRouteMeta = route => {
  if (route.meta.adminSettingsAccess) {
    return canAccessAdminSettings(ability.can.bind(ability))
  }
  if (route.meta.clientDashboardAccess) {
    return canAccessClientDashboard(ability.can.bind(ability))
  }
  const action = route.meta.action || 'read'
  if (route.meta.resourceAny && Array.isArray(route.meta.resourceAny)) {
    return route.meta.resourceAny.some(resource => ability.can(action, resource))
  }
  return ability.can(action, route.meta.resource)
}

export const canNavigate = to => to.matched.some(canAccessRouteMeta)

export const _ = undefined
